/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React, {} from 'react';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import {BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Music from './pages/Music';
import Artists from './pages/Artists';
import Videos from './pages/Videos';
import Links from './pages/Links'
import Events from './pages/Events';
import DonAero from './pages/DonAero'
import Melodico from './pages/Melodico';
import Swat from './pages/Swat';
import DubG from './pages/DubG';
import OscarC from './pages/OscarC';
import About from './pages/About';
import Contact from './pages/Contact';


function App() {
  

  return (
    <>
    <Router>
    <Navbar />
    <Switch>
      <Route path='/' exact component={Home} />
      <Route path='/music' exact component={Music} />
      <Route path='/videos' exact component={Videos} />
      <Route path='/artists' exact component={Artists} />
      <Route path='/links' exact component={Links}/>
      <Route path='/events' exact component={Events}/>
      <Route path='/donaero' exact component={DonAero}/>
      <Route path='/melodico' exact component={Melodico}/>
      <Route path='/swat' exact component={Swat}/>
      <Route path='/dubg' exact component={DubG}/>
      <Route path='/oscarc' exact component={OscarC}/>
      <Route path='/about' exact component={About} />
      <Route path='/contact' exact component={Contact}/>
    </Switch>
    </Router>
    </>
  );
}

export default App;
